import PropTypes from 'prop-types'

const CartOperationStatus = ({
  pending,
  unconfirmed,
  message,
  language,
  onRefresh,
}) => {
  const th = language?.split('-')[0] === 'th'
  if (pending) {
    return (
      <div role="status" style={{ padding: '12px 20px' }}>
        {th ? 'กำลังอัปเดตถุงช้อปปิ้ง…' : 'Updating your bag…'}
      </div>
    )
  }
  if (!unconfirmed)
    return message ? (
      <div role="alert" style={{ padding: '12px 20px' }}>
        {message}
      </div>
    ) : null
  return (
    <div role="alert" style={{ padding: '12px 20px' }}>
      <p>
        {th
          ? 'ยังยืนยันยอดรวมไม่ได้ กรุณารีเฟรชถุงช้อปปิ้งก่อนชำระเงิน'
          : 'We couldn’t confirm your total. Refresh your bag before checkout.'}
      </p>
      <button type="button" onClick={onRefresh}>
        {th ? 'รีเฟรชถุงช้อปปิ้ง' : 'Refresh bag'}
      </button>
    </div>
  )
}

CartOperationStatus.propTypes = {
  pending: PropTypes.bool,
  unconfirmed: PropTypes.bool,
  language: PropTypes.string,
  message: PropTypes.string,
  onRefresh: PropTypes.func.isRequired,
}
CartOperationStatus.defaultProps = {
  pending: false,
  unconfirmed: false,
  message: null,
  language: 'en',
}
export default CartOperationStatus
